import { useState } from 'react';
import { Modal } from '../../ui/modal.js';
import { Spinner } from '../../FormBits.js';

/** Asked when another client is picked while this client's draft has unsaved typing. */
export function UnsavedSwitchDialog({
  clientName,
  onSave,
  onDiscard,
  onStay,
}: {
  clientName: string;
  onSave: () => Promise<void>;
  onDiscard: () => void;
  onStay: () => void;
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const save = async () => {
    setBusy(true);
    setError(null);
    try {
      await onSave();
    } catch (e) {
      setError((e as Error).message);
      setBusy(false);
    }
  };
  const btn = 'flex items-center gap-2 rounded-md px-4 py-2 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-50';
  return (
    <Modal
      open
      title="שינויים שלא נשמרו"
      onClose={onStay}
      footer={
        <>
          <button type="button" disabled={busy} onClick={onStay} className={`${btn} border border-border hover:bg-muted`}>
            להישאר
          </button>
          <button type="button" disabled={busy} onClick={onDiscard} className={`${btn} border border-destructive/50 text-destructive hover:bg-destructive/10`}>
            לזרוק
          </button>
          <button type="button" disabled={busy} onClick={save} className={`${btn} bg-primary text-primary-foreground hover:opacity-90`}>
            {busy && <Spinner />}
            לשמור
          </button>
        </>
      }
    >
      <p className="text-sm">
        יש שינויים שלא נשמרו בטיוטה של {clientName}. לשמור אותם כטיוטה לפני המעבר, לזרוק אותם, או להישאר בלקוח הזה?
      </p>
      <p className="mt-2 text-xs text-muted-foreground">שמירה כטיוטה לא מפרסמת דבר ללקוח.</p>
      {error && <p role="alert" className="mt-3 text-sm text-destructive" dir="auto">השמירה נכשלה: {error}</p>}
    </Modal>
  );
}
